// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { body1FontSize, body1LineHeight, display1FontSizeSmall, display2FontSizeSmall, display2FontSizeXSmall, heading1FontSizeXSmall, heading2LineHeight, heading3FontSize, heading3LineHeight, screenXsMax, screenSmMax, spacer8, spacer16, spacer24, spacer56, Type } from '@spotify-internal/encore-web';
import { DELAYS, withAnimationContext, fadeInAnimation } from '../../../ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Testimony = styled.div.withConfig({
  displayName: "Testimonial__Testimony",
  componentId: "sc-1b6lsts-0"
})(["display:flex;flex-direction:column;text-align:", ";"], function (props) {
  return props.centered ? 'center' : 'left';
});
var TestimonialChar = withAnimationContext(styled.blockquote.attrs({
  weight: 'bold'
}).withConfig({
  displayName: "Testimonial__TestimonialChar",
  componentId: "sc-1b6lsts-1"
})(["", ";line-height:14px;font-size:", ";padding:0;border:0;margin:0;", ";@media (max-width:", "){font-size:", ";", ";}@media (max-width:", "){font-size:", ";}"], fadeInAnimation(DELAYS.SECOND), display1FontSizeSmall, function (props) {
  return props.isHero ? "padding-top: ".concat(spacer56) : "padding-top: ".concat(spacer24);
}, screenSmMax, display2FontSizeSmall, function (props) {
  return props.isHero ? "padding-top: ".concat(spacer56) : "padding-top: ".concat(spacer16);
}, screenXsMax, display2FontSizeXSmall)); // TODO: the font-size and line-heights below come directly from
// figma specs.  need to find a better way to do this

var TestimonialBody = withAnimationContext(styled(Type.p).attrs({
  paddingBottom: '0.75em',
  variant: 'alto',
  weight: 'book'
}).withConfig({
  displayName: "Testimonial__TestimonialBody",
  componentId: "sc-1b6lsts-2"
})(["", ";@media (max-width:", "){", "}@media (max-width:", "){", "}"], fadeInAnimation(DELAYS.THIRD), screenSmMax, function (props) {
  if (props.isHero) {
    if (props.centered) {
      return "font-size: ".concat(heading1FontSizeXSmall, "; line-height: ").concat(heading2LineHeight, ";");
    }

    return "font-size: 18px; line-height: ".concat(body1LineHeight, ";");
  }

  return "font-size: ".concat(body1FontSize, "; line-height: ").concat(body1LineHeight, ";");
}, screenXsMax, function (props) {
  if (props.isHero) {
    if (props.centered) {
      return "font-size: ".concat(heading3FontSize, "; line-height: ").concat(heading3LineHeight, ";");
    }
  }

  return '';
}));
var TestimonialSource = withAnimationContext(styled(Type.h1).attrs({
  variant: 'celloCanon',
  weight: 'bold'
}).withConfig({
  displayName: "Testimonial__TestimonialSource",
  componentId: "sc-1b6lsts-3"
})(["", ";padding-bottom:0px;@media (max-width:", "){", ";}"], fadeInAnimation(DELAYS.FOURTH), screenSmMax, function (props) {
  return props.centered && props.isHero || !props.isHero ? '' : "visibility: hidden;";
}));
var SourceTitle = withAnimationContext(styled(Type.p).attrs({
  variant: 'minuetBold'
}).withConfig({
  displayName: "Testimonial__SourceTitle",
  componentId: "sc-1b6lsts-4"
})(["", ";padding-top:", ";@media (max-width:", "){", ";}"], fadeInAnimation(DELAYS.FIFTH), spacer8, screenSmMax, function (props) {
  return props.centered && props.isHero || !props.isHero ? '' : "visibility: hidden;";
}));
export var Testimonial = function Testimonial(_ref) {
  var _ref$quote = _ref.quote,
      quote = _ref$quote === void 0 ? '' : _ref$quote,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? '' : _ref$source,
      _ref$jobTitle = _ref.jobTitle,
      jobTitle = _ref$jobTitle === void 0 ? '' : _ref$jobTitle,
      _ref$centered = _ref.centered,
      centered = _ref$centered === void 0 ? false : _ref$centered,
      _ref$isHero = _ref.isHero,
      isHero = _ref$isHero === void 0 ? false : _ref$isHero;
  return /*#__PURE__*/_jsxs(Testimony, {
    centered: centered,
    children: [/*#__PURE__*/_jsx(TestimonialChar, {
      isHero: isHero,
      className: "quote-char",
      children: "\u201C"
    }), /*#__PURE__*/_jsx(TestimonialBody, {
      centered: centered,
      isHero: isHero,
      children: quote
    }), /*#__PURE__*/_jsxs(TestimonialSource, {
      centered: centered,
      isHero: isHero,
      children: [' ', "\u2014 ", source]
    }), /*#__PURE__*/_jsx(SourceTitle, {
      centered: centered,
      isHero: isHero,
      children: jobTitle
    })]
  });
};